<footer class="footer">
    <div class="d-flex justify-content-center align-items-center gap-2">
        <a href="https://www.hoastart.com" target="_blank" rel="noopener noreferrer" class="footer-link text-decoration-none">© 2026 HOA Start</a>
        <dev-bootstrap-size />
    </div>
</footer>